/* Mens Ring PDP — gallery, native width/finish/size variants, sticky ATC w/ size guard,
   delivery estimator, engraving-express guard (BCPO), swatch width handshake.
   "finish" = the product's third option axis (Inlay, Color, Plating, Stone…) when it has one;
   it is a VARIANT on this product, so it selects in place — the .mrp-color-dot links are a
   separate, cross-product mechanism (design_family siblings) and stay untouched. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- data ---------- */
  var variants = [];
  try { variants = JSON.parse(($('#mrpVariants') || {}).textContent || '[]'); } catch (e) { variants = []; }
  var hasWidth = variants.some(function (v) { return v.w; });
  var hasFinish = variants.some(function (v) { return v.f; });

  /* ---------- title clamp ---------- */
  var title = $('#mrpTitle'), more = $('#mrpTitleMore');
  if (title && more) {
    if (title.scrollHeight > title.clientHeight + 2) more.hidden = false;
    more.addEventListener('click', function () {
      var open = title.classList.toggle('expanded');
      more.textContent = open ? 'Show less' : 'Read more';
      more.setAttribute('aria-expanded', open);
    });
  }

  /* ---------- gallery ---------- */
  var slides = $$('.mrp-slide'), thumbs = $$('.mrp-thumb');
  function showSlide(i) {
    slides.forEach(function (s) { s.classList.toggle('active', +s.dataset.idx === i); var vid = s.querySelector('video'); if (vid && +s.dataset.idx !== i) { vid.pause(); s.classList.remove('playing'); } });
    thumbs.forEach(function (t) { t.classList.toggle('active', +t.dataset.idx === i); });
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlide(+t.dataset.idx); }); });
  /* arrow / swipe navigation — step through slides; keep the active thumb in view
     when the mobile thumb row scrolls (horizontal only, never scrolls the page) */
  function centerThumb() {
    var at = thumbs.filter(function (t) { return t.classList.contains('active'); })[0];
    var tw = at && at.parentElement;
    if (!tw || tw.scrollWidth <= tw.clientWidth) return;
    var target = at.offsetLeft - (tw.clientWidth - at.offsetWidth) / 2;
    if (tw.scrollTo) { tw.scrollTo({ left: target, behavior: 'smooth' }); } else { tw.scrollLeft = target; }
  }
  function stepSlide(d) {
    var n = slides.length;
    if (n < 2) return;
    var a = slides.filter(function (s) { return s.classList.contains('active'); })[0];
    var cur = a ? +a.dataset.idx : 0;
    showSlide(((cur + d) % n + n) % n);
    centerThumb();
  }
  var navPrev = $('.mrp-nav-prev'), navNext = $('.mrp-nav-next');
  if (navPrev) navPrev.addEventListener('click', function () { stepSlide(-1); });
  if (navNext) navNext.addEventListener('click', function () { stepSlide(1); });
  var galMain = $('.mrp-main');
  if (galMain && slides.length > 1) {
    var swX = 0, swY = 0, swOn = false;
    galMain.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { swOn = false; return; }
      swOn = true; swX = e.touches[0].clientX; swY = e.touches[0].clientY;
    }, { passive: true });
    galMain.addEventListener('touchend', function (e) {
      if (!swOn) return;
      swOn = false;
      var dx = e.changedTouches[0].clientX - swX, dy = e.changedTouches[0].clientY - swY;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) stepSlide(dx < 0 ? 1 : -1);
    }, { passive: true });
  }
  $$('.mrp-video-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var slide = btn.closest('.mrp-slide'), vid = slide.querySelector('video');
      if (!vid) return;
      if (vid.paused) { vid.play(); slide.classList.add('playing'); } else { vid.pause(); slide.classList.remove('playing'); }
    });
  });
  var lb = $('#mrpLightbox'), lbImg = $('#mrpLbImg');
  $$('.mrp-slide img[data-zoom]').forEach(function (img) {
    img.addEventListener('click', function () { if (lb) { lbImg.src = img.dataset.zoom; lb.hidden = false; } });
  });
  if (lb) { lb.addEventListener('click', function () { lb.hidden = true; lbImg.src = ''; }); }

  /* ---------- width / finish / size ---------- */
  var widthWrap = $('#mrpWidths'), widthName = $('#mrpWidthName'), sizeSel = $('#mrpSize');
  var finishWrap = $('#mrpFinishes'), finishName = $('#mrpFinishName');
  var finishOptName = ((finishWrap && finishWrap.dataset.opt) || '').trim().toLowerCase();
  var variantInput = $('#mrpVariantId'), atc = $('#mrpAtc'), price = $('#mrpPrice');

  /* ---------- size validation: visible message + a11y state ----------
     The guard below already blocked the add and moved focus, but said nothing — silent to
     sighted users whose selector was off-screen, and invisible to assistive tech.
     SCOPE: this adds the message ONLY. The Add to Cart button's label is left exactly as the
     theme renders it — an earlier attempt to relabel it to "Choose size" was reverted. */
  var sizeErr = null;
  if (sizeSel) {
    sizeErr = document.createElement('div');
    sizeErr.className = 'mrp-size-error';
    sizeErr.setAttribute('role', 'alert');
    sizeErr.textContent = 'Choose a ring size to continue';
    sizeErr.hidden = true;
    /* theme accent purple — same #4C3799 as "Find my ring size" and the "$30 value" badge,
       so the prompt reads as part of the page rather than as an error */
    /* margin-top:0 deliberately — #mrpSize already carries an 8px bottom margin, and these are
       flex siblings so the margins do not collapse. Adding our own made a 16px gap that read as
       belonging to the note below rather than to the selector above. */
    sizeErr.style.cssText = 'color:#4C3799;font-size:.875rem;line-height:1.3;margin-top:0;font-weight:500;';
    sizeSel.insertAdjacentElement('afterend', sizeErr);
  }
  function showSizeError() {
    if (!sizeErr) return;
    sizeErr.hidden = false;
    sizeSel.setAttribute('aria-invalid', 'true');
  }
  function clearSizeError() {
    if (!sizeErr || sizeErr.hidden) return;
    sizeErr.hidden = true;
    sizeSel.removeAttribute('aria-invalid');
  }

  var priceWas = $('#mrpPriceWas'), priceWasAmt = $('#mrpPriceWasAmt'), priceSave = $('#mrpPriceSave');
  var stickySub = $('#mrpStickySub'), stickyBtn = $('#mrpStickyBtn');
  function currentWidth() {
    var sel = widthWrap && widthWrap.querySelector('button.sel');
    return sel ? sel.dataset.w : '';
  }
  function currentFinish() {
    var sel = finishWrap && finishWrap.querySelector('button.sel');
    return sel ? sel.dataset.f : '';
  }
  function buildSizes() {
    if (!sizeSel) return;
    var w = currentWidth(), f = currentFinish(), prev = sizeSel.value;
    var opts = variants.filter(function (v) { return (!hasWidth || v.w === w) && (!hasFinish || v.f === f); });
    var html = '<option value="">Select your size</option>';
    opts.forEach(function (v) { html += '<option value="' + v.s + '"' + (v.a ? '' : ' disabled') + (v.s === prev ? ' selected' : '') + '>' + v.s + (v.a ? '' : ' — sold out') + '</option>'; });
    sizeSel.innerHTML = html;
    if (prev && sizeSel.value !== prev) sizeSel.value = '';
    syncVariant();
  }
  function syncVariant() {
    var w = currentWidth(), f = currentFinish(), s = sizeSel ? sizeSel.value : '';
    var match = variants.filter(function (v) { return (!hasWidth || v.w === w) && (!hasFinish || v.f === f) && (!s || v.s === s); })[0];
    if (match) {
      if (variantInput && String(variantInput.value) !== String(match.id)) variantInput.value = match.id;
      if (price && price.textContent !== match.p) price.textContent = match.p;
      /* compare-at: variants carry cap (crossed-out original) and sv (savings) when on sale — "" otherwise */
      if (price) price.classList.toggle('on-sale', !!match.cap);
      if (priceWas) {
        if (match.cap) {
          if (priceWasAmt && priceWasAmt.textContent !== match.cap) priceWasAmt.textContent = match.cap;
          priceWas.hidden = false;
        } else if (!priceWas.hidden) { priceWas.hidden = true; }
      }
      if (priceSave) {
        if (match.sv) {
          var svTxt = 'Save ' + match.sv;
          if (priceSave.textContent !== svTxt) priceSave.textContent = svTxt;
          priceSave.hidden = false;
        } else if (!priceSave.hidden) { priceSave.hidden = true; }
      }
      if (atc && !atc.disabled) {
        var label = atc.textContent.split('—')[0].trim() + ' — ' + match.p;
        if (atc.textContent !== label) atc.textContent = label;
      }
    }
    if (stickySub) {
      /* sale price only — no crossed-out original here; width+size+two prices wraps the bar on mobile (couples sticky keeps its strikethrough: shorter line, no options) */
      var st = (hasWidth ? w + ' · ' : '') + (hasFinish ? f + ' · ' : '') + (s ? 'size ' + s : 'choose your size') + (match ? ' · ' + match.p : '');
      if (stickySub.textContent !== st) stickySub.textContent = st;
    }
    if (stickyBtn) {
      var bt = s ? 'Add to cart' : 'Choose size';
      if (stickyBtn.textContent !== bt) stickyBtn.textContent = bt;
    }
    updateSwatchTargets(w, s);
    syncBcpoSelectors(w, s, f);
  }
  /* BCPO overwrites [name=id] from ITS hidden Width/Finish/Ring-size selectors on their change events —
     drive them to match our native pickers so whatever BCPO computes is always the right variant */
  function syncBcpoSelectors(w, s, f) {
    var form = $('#mrp-form');
    if (!form) return;
    $$('.selector-wrapper', form).forEach(function (g) {
      var t = g.querySelector('.bcpo-title');
      if (!t) return;
      var name = t.textContent.trim().toLowerCase();
      var val = '';
      if (/^width/.test(name)) { val = w; }
      else if (/^ring size/.test(name)) { val = s; }
      else if (finishOptName && name.indexOf(finishOptName) === 0) { val = f; }
      if (!val) return;
      var sel = g.querySelector('select');
      if (sel) {
        if (sel.value === val) return;
        var has = Array.prototype.some.call(sel.options, function (o) { return o.value === val; });
        if (has) { sel.value = val; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      } else {
        var radio = $$('input[type="radio"]', g).filter(function (r) { return r.value === val; })[0];
        if (radio && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
      }
    });
  }
  if (widthWrap) {
    $$('button', widthWrap).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('button', widthWrap).forEach(function (x) { x.classList.remove('sel'); });
        b.classList.add('sel');
        if (widthName) widthName.textContent = b.dataset.w;
        buildSizes();
      });
    });
  }
  if (finishWrap) {
    $$('button', finishWrap).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('button', finishWrap).forEach(function (x) { x.classList.remove('sel'); });
        b.classList.add('sel');
        if (finishName) finishName.textContent = b.dataset.f;
        buildSizes();
      });
    });
  }
  /* dismiss the prompt as soon as a size is picked, then the theme's original sync */
  if (sizeSel) sizeSel.addEventListener('change', function () { clearSizeError(); syncVariant(); });
  buildSizes();
  /* default to 8mm (most popular) when no explicit width/variant in the URL */
  (function () {
    var p = new URLSearchParams(window.location.search);
    if (!p.get('w') && !p.get('variant') && widthWrap) {
      var btns = $$('button', widthWrap);
      var pref = btns.filter(function (b) { return b.dataset.w === '8mm'; })[0] || btns[btns.length - 1];
      if (pref && !pref.classList.contains('sel')) pref.click();
    }
  })();

  /* ---------- main ATC size guard: never add to cart without a chosen size ----------
     Registered at DOCUMENT capture so it fires before any app handler (BCPO hooks
     add-to-cart itself and its hidden Ring-Size selector supplies a default variant). */
  function needsSize() { return sizeSel && !sizeSel.value; }
  function focusSize() {
    showSizeError();
    sizeSel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { sizeSel.focus(); }, 450);
  }
  function sizeGuard(e) {
    if (!needsSize()) return;
    var onAtc = e.type === 'click' && e.target && e.target.closest && e.target.closest('#mrpAtc');
    var onForm = e.type === 'submit' && e.target && e.target.id === 'mrp-form';
    if (onAtc || onForm) { e.preventDefault(); e.stopImmediatePropagation(); focusSize(); }
  }
  document.addEventListener('click', sizeGuard, true);
  document.addEventListener('submit', sizeGuard, true);

  /* ---------- sticky ATC + size guard ---------- */
  var sticky = $('#mrpSticky');
  if (sticky && atc) {
    function onScroll() { sticky.classList.toggle('show', atc.getBoundingClientRect().bottom <= 0); }
    window.addEventListener('scroll', onScroll); window.addEventListener('resize', onScroll);
    stickyBtn.addEventListener('click', function () {
      if (sizeSel && !sizeSel.value) {
        focusSize();
      } else {
        var form = $('#mrp-form'); if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      }
    });
  }

  /* ---------- delivery estimator (cutoff CT + processing + transit, optional Saturdays) ---------- */
  var del = $('#mrpDelivery');
  var engraveDays = 0; /* engraving adds 3 business days of processing */
  function renderDelivery() {
    if (!del) return;
    var fmt = function (d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); };
    var addBiz = function (date, days, sat) {
      var d = new Date(date);
      while (days > 0) { d.setDate(d.getDate() + 1); var dow = d.getDay(); if (dow === 0) continue; if (dow === 6 && !sat) continue; days--; }
      return d;
    };
    try {
      var nowCT = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' }));
      var sat = del.dataset.saturdays === '1';
      var start = new Date(nowCT);
      if (nowCT.getHours() >= +del.dataset.cutoff) start.setDate(start.getDate() + 1);
      var early = addBiz(start, (+del.dataset.processingMin || 1) + engraveDays + (+del.dataset.transitMin || 3), sat);
      var late = addBiz(start, (+del.dataset.processing || 2) + engraveDays + (+del.dataset.transitMax || 5), sat);
      var out = $('#mrpDeliveryDates'), txt = fmt(early) + ' – ' + fmt(late);
      /* keep the whole date range on one line: without this the break lands between month and
         day ("Sep" / "8"), splitting a date across two lines. The range is ~140px, so it always
         fits even at 320px — it just moves to the next line as a unit. */
      if (out && out.style.whiteSpace !== 'nowrap') out.style.whiteSpace = 'nowrap';
      if (out && out.textContent !== txt) out.textContent = txt;
    } catch (e) { /* keep fallback text */ }
  }
  renderDelivery();

  /* ---------- engraving guard: BCPO injects async, watch the form ---------- */
  var form = $('#mrp-form'), express = $('#mrpExpress'), engraveNote = $('#mrpEngraveNote');
  /* BCPO renders its own Width + Finish + Ring size selectors (duplicates of our native ones) — hide those groups, keep engraving */
  function hideBcpoDupes() {
    if (!form) return;
    $$('.selector-wrapper', form).forEach(function (g) {
      var t = g.querySelector('.bcpo-title');
      if (!t) return;
      var txt = t.textContent.trim();
      if (/^(width|ring size)/i.test(txt) || (finishOptName && txt.toLowerCase().indexOf(finishOptName) === 0)) g.style.display = 'none';
    });
  }
  function engravingGuard() {
    if (!form) return;
    var filled = $$('input[type="text"], textarea', form).some(function (f) { return f.name !== 'id' && f.value && f.value.trim().length > 0; });
    if (express) express.classList.toggle('engraving-on', filled);
    if (engraveNote) engraveNote.hidden = !filled;
    var extra = filled ? 3 : 0;
    if (extra !== engraveDays) { engraveDays = extra; renderDelivery(); }
  }
  if (form) {
    form.addEventListener('input', engravingGuard);
    /* BCPO injects async in bursts — COALESCE mutations into a trailing run (never drop them),
       write-guards in syncVariant keep this loop-safe. */
    var moScheduled = false;
    function reassert() { try { hideBcpoDupes(); engravingGuard(); syncVariant(); } catch (e) { } }
    new MutationObserver(function () {
      if (moScheduled) return;
      moScheduled = true;
      setTimeout(function () { moScheduled = false; reassert(); }, 60);
    }).observe(form, { childList: true, subtree: true });
    reassert();
    /* safety sweep while BCPO settles (it can take up to 60s to inject) */
    var sweeps = 0;
    var sweepTimer = setInterval(function () { hideBcpoDupes(); if (++sweeps >= 60) clearInterval(sweepTimer); }, 1000);
  }

  /* ---------- color swatch width handshake (cross-product design_family links) ---------- */
  function updateSwatchTargets(w, s) {
    $$('.mrp-color-dot[data-targets]').forEach(function (dot) {
      var targets = [];
      try { targets = JSON.parse(dot.dataset.targets); } catch (e) { return; }
      var exact = targets.filter(function (t) { return t.widths.length === 1 && t.widths[0] === w; })[0];
      var multi = targets.filter(function (t) { return t.widths.indexOf(w) !== -1; })[0];
      var pick = exact || multi || targets[0];
      if (pick) { dot.dataset.href = pick.url; dot.title = dot.dataset.name + (multi || exact ? '' : ' — available in ' + pick.widths.join(' & ')); }
    });
  }
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.mrp-color-dot[data-targets]');
    if (!dot) return;
    e.preventDefault();
    var url = dot.dataset.href || dot.getAttribute('href');
    var w = currentWidth(), s = sizeSel ? sizeSel.value : '';
    var q = [];
    if (w) q.push('w=' + encodeURIComponent(w));
    if (s) q.push('s=' + encodeURIComponent(s));
    /* dual-color target: land with its matching pill preselected (arrival matches ?f= case-insensitively) */
    if (dot.dataset.f) q.push('f=' + encodeURIComponent(dot.dataset.f));
    window.location.href = url + (q.length ? (url.indexOf('?') === -1 ? '?' : '&') + q.join('&') : '');
  });
  /* arrival handshake: preselect ?w=, ?f= and ?s= (f matches case-insensitively — dots pass
     downcased metafield colors like 'rose gold' while pill values read 'Rose gold') */
  (function () {
    var p = new URLSearchParams(window.location.search);
    var w = p.get('w'), f = p.get('f'), s = p.get('s');
    if (w && widthWrap) {
      var btn = $$('button', widthWrap).filter(function (b) { return b.dataset.w === w; })[0];
      if (btn) btn.click();
    }
    if (f && finishWrap) {
      var fl = f.trim().toLowerCase();
      var fbtn = $$('button', finishWrap).filter(function (b) { return (b.dataset.f || '').trim().toLowerCase() === fl; })[0];
      if (fbtn) fbtn.click();
    }
    if (s && sizeSel) {
      sizeSel.value = s;
      if (sizeSel.value === s) syncVariant();
    }
  })();

  /* ---------- related products: swap the static fallback for Shopify's per-product recommendations ---------- */
  var relBody = $('[data-csp-recommendations]');
  if (relBody) {
    fetch(relBody.dataset.cspRecommendations)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-csp-recommendations]');
        if (fresh && fresh.querySelector('.cs-pcard')) relBody.innerHTML = fresh.innerHTML;
        syncRelNav();
      })
      .catch(function () { /* keep collection fallback */ });
  }

  /* ---------- related-rings slider arrows (desktop mouse users) ---------- */
  var relWrap = $('.cs-rel-slider');
  function syncRelNav() {
    if (!relWrap) return;
    var r = relWrap.querySelector('.cs-prow');
    var prev = relWrap.querySelector('.cs-rel-prev'), next = relWrap.querySelector('.cs-rel-next');
    if (!r || !prev) return;
    prev.disabled = r.scrollLeft <= 4;
    next.disabled = r.scrollLeft >= r.scrollWidth - r.clientWidth - 4;
  }
  if (relWrap) {
    /* native smooth scroll AND rAF are unreliable under this theme's scripts —
       tween with setInterval and land exactly on the target */
    var relTimer = null;
    var relPage = function (dir) {
      var r = relWrap.querySelector('.cs-prow');
      if (!r) return;
      var start = r.scrollLeft;
      var target = Math.max(0, Math.min(start + dir * r.clientWidth * 0.9, r.scrollWidth - r.clientWidth));
      if (relTimer) clearInterval(relTimer);
      var t0 = Date.now(), dur = 320;
      relTimer = setInterval(function () {
        var p = Math.min((Date.now() - t0) / dur, 1);
        var ease = 1 - Math.pow(1 - p, 3);
        r.scrollLeft = start + (target - start) * ease;
        if (p >= 1) {
          clearInterval(relTimer); relTimer = null;
          r.scrollLeft = target;
          syncRelNav();
        }
      }, 16);
    };
    var rp = relWrap.querySelector('.cs-rel-prev'), rn = relWrap.querySelector('.cs-rel-next');
    if (rp) rp.addEventListener('click', function () { relPage(-1); });
    if (rn) rn.addEventListener('click', function () { relPage(1); });
    relWrap.addEventListener('scroll', syncRelNav, true);
    window.addEventListener('resize', syncRelNav);
    syncRelNav();
  }

  /* ---------- sizing help, matched to the couples PDP ----------
     The strongest sizing reassurance this store has is that a sizer ships with the ring — it
     resolves the hesitation without asking anyone to wait. Replaces the guess advice, which
     manufactured the exchanges the guarantee then paid for.
     No product gating needed: .mrp-sizenote is only rendered for products that HAVE a size
     option, so it never appears on the wood ring box (verified — zero occurrences there). */
  var mrpNote1 = $('.mrp-sizenote-1');
  var mrpNote2 = $('.mrp-sizenote-2');
  if (mrpNote1) mrpNote1.textContent = '✓ A ring sizer ships with every order';
  if (mrpNote2) mrpNote2.textContent = 'Confirm at home — free size exchange.';
  /* Ruler icon only — the link is NOT repositioned here. On couples it sat orphaned above both
     dropdowns; on this template it is already inline with the "Ring size" label, which is the
     conventional spot and does not wrap. Moving it would stack a third helper line under the
     selector for no gain. */
  (function () {
    var sizeLink = $('#mrpSizeOpen');
    if (!sizeLink || sizeLink.querySelector('svg')) return;
    sizeLink.style.display = 'inline-flex';
    sizeLink.style.alignItems = 'center';
    sizeLink.style.gap = '6px';
    sizeLink.insertAdjacentHTML('afterbegin',
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<rect x="2" y="8" width="20" height="8" rx="1.5"/>' +
      '<path d="M6.5 8v3M10 8v4M13.5 8v3M17.5 8v4"/></svg>');
  })();

  /* ---------- ring sizer modal (full couples-set port: calibration, dial, chart) ---------- */
  var RS_SIZES = [
    {us:'4',dia:14.9,circ:46.8,uk:'H½',eu:47},
    {us:'4.5',dia:15.3,circ:48.0,uk:'I½',eu:48},
    {us:'5',dia:15.7,circ:49.3,uk:'J½',eu:49},
    {us:'5.5',dia:16.1,circ:50.6,uk:'K½',eu:51},
    {us:'6',dia:16.5,circ:51.9,uk:'L½',eu:52},
    {us:'6.5',dia:16.9,circ:53.1,uk:'M½',eu:53},
    {us:'7',dia:17.3,circ:54.4,uk:'N½',eu:54},
    {us:'7.5',dia:17.7,circ:55.7,uk:'O½',eu:56},
    {us:'8',dia:18.1,circ:57.0,uk:'P½',eu:57},
    {us:'8.5',dia:18.5,circ:58.3,uk:'Q½',eu:58},
    {us:'9',dia:18.9,circ:59.5,uk:'R½',eu:60},
    {us:'9.5',dia:19.4,circ:60.8,uk:'S½',eu:61},
    {us:'10',dia:19.8,circ:62.1,uk:'T½',eu:62},
    {us:'10.5',dia:20.2,circ:63.4,uk:'U½',eu:63},
    {us:'11',dia:20.6,circ:64.6,uk:'V½',eu:65},
    {us:'11.5',dia:21.0,circ:65.9,uk:'W½',eu:66},
    {us:'12',dia:21.4,circ:67.2,uk:'Y',eu:67},
    {us:'12.5',dia:21.8,circ:68.5,uk:'Z',eu:69},
    {us:'13',dia:22.2,circ:69.7,uk:'Z+1',eu:70},
    {us:'13.5',dia:22.6,circ:71.0,uk:'Z+2',eu:71},
    {us:'14',dia:23.0,circ:72.3,uk:'Z+3',eu:72},
    {us:'14.5',dia:23.4,circ:73.6,uk:'Z+4',eu:74},
    {us:'15',dia:23.8,circ:74.8,uk:'Z+5',eu:75}
  ];
  var rsModal = $('#rsModal');
  if (rsModal) {
    var rsOpen = $('#mrpSizeOpen');
    var rsCal = $('#rsCal'), rsCard = $('#rsCard'), rsSize = $('#rsSize'), rsRing = $('#rsRing'), rsRead = $('#rsReadout');

    function rsUpdate() {
      if (!rsCal || !rsSize) return;
      var cardPx = +rsCal.value;
      if (rsCard) {
        /* ISO ID-1 card = 85.6mm tall x 53.98mm wide (held upright). Set both
           dimensions explicitly so the short side stays accurate regardless of
           any theme .rs-card overrides. */
        rsCard.style.setProperty('height', cardPx + 'px', 'important');
        rsCard.style.setProperty('width', (Math.round(cardPx * 53.98 / 85.6 * 10) / 10) + 'px', 'important');
        rsCard.style.setProperty('max-width', 'none', 'important');
      }
      var pxPerMm = cardPx / 85.6;
      var s = RS_SIZES[+rsSize.value];
      var d = Math.round(s.dia * pxPerMm);
      if (rsRing) {
        /* the ring's inside diameter should equal the INNER edge of the stroke,
           so grow the (border-box) circle by the stroke width on each side */
        var bw = parseFloat(getComputedStyle(rsRing).borderTopWidth) || 1;
        var outer = d + 2 * bw;
        rsRing.style.width = outer + 'px';
        rsRing.style.height = outer + 'px';
      }
      if (rsRead) rsRead.textContent = 'US ' + s.us + '  ·  ' + s.dia + ' mm  ·  UK ' + s.uk + '  ·  EU ' + s.eu;
    }
    function rsShow() { rsModal.hidden = false; document.body.style.overflow = 'hidden'; rsUpdate(); }
    function rsHide() { rsModal.hidden = true; document.body.style.overflow = ''; }

    if (rsOpen) rsOpen.addEventListener('click', rsShow);
    $$('[data-rs-close]', rsModal).forEach(function (el) { el.addEventListener('click', rsHide); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !rsModal.hidden) rsHide(); });

    /* ---------- sizing methods: order fastest-first, then offer the mailed sizer ----------
       Same treatment as the couples PDP. Theme ships print / dial / chart with print landing;
       printable is the only method needing a printer, so it should not be the default. Runs
       BEFORE the tab handlers below so the new tab is wired by the same code as the originals.
       Panel styles are inline — the .rs-btn classes are defined for the standalone sizer page,
       not verified inside this modal. */
    var mrpTabs = $('.rs-tabs', rsModal);
    if (mrpTabs) {
      if (!document.getElementById('rs-tabstrip-css')) {
        var mrpTabCss = document.createElement('style');
        mrpTabCss.id = 'rs-tabstrip-css';
        mrpTabCss.textContent =
          '#rsModal .rs-tabs{display:flex;flex-wrap:nowrap;overflow-x:auto;gap:20px;' +
          'scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch}' +
          '#rsModal .rs-tabs::-webkit-scrollbar{display:none}' +
          '#rsModal .rs-tab{white-space:nowrap;flex:0 0 auto}';
        document.head.appendChild(mrpTabCss);
      }
      var mrpTab = function (k) { return $('.rs-tab[data-tab="' + k + '"]', rsModal); };
      var mrpPanel = function (k) { return $('.rs-panel[data-panel="' + k + '"]', rsModal); };
      ['dial', 'chart', 'print'].forEach(function (k) {
        var t = mrpTab(k); if (t) { mrpTabs.appendChild(t); t.classList.remove('active'); }
        var p = mrpPanel(k); if (p) p.classList.remove('active');
      });
      var mrpDialTab = mrpTab('dial'), mrpDialPanel = mrpPanel('dial');
      if (mrpDialTab) mrpDialTab.classList.add('active');
      if (mrpDialPanel) mrpDialPanel.classList.add('active');

      if (!mrpTab('mail')) {
        var mailTab = document.createElement('button');
        mailTab.type = 'button';
        mailTab.className = 'rs-tab';
        mailTab.setAttribute('data-tab', 'mail');
        mailTab.textContent = 'Free sizer by mail';
        mrpTabs.appendChild(mailTab);

        var mailPanel = document.createElement('div');
        mailPanel.className = 'rs-panel';
        mailPanel.setAttribute('data-panel', 'mail');
        mailPanel.innerHTML =
          '<div style="background:#F7F4FC;border-radius:10px;padding:14px;">' +
            '<p style="margin:0 0 6px;font-size:14px;font-weight:500;color:#3C3489;">Rather size before you order?</p>' +
            '<p style="margin:0 0 12px;font-size:13px;line-height:1.5;color:#534AB7;">We\'ll mail you a free plastic sizer with $5 credit toward your ring. US only. A sizer also ships with every ring order.</p>' +
            '<form method="post" action="/cart/add">' +
              '<input type="hidden" name="id" value="45538170404995">' +
              '<button type="submit" style="width:100%;background:#4C3799;color:#fff;border:0;border-radius:9px;padding:12px;font:inherit;font-size:14px;font-weight:500;cursor:pointer;">Get a free ring sizer</button>' +
            '</form>' +
          '</div>';
        var mrpPanels = $$('.rs-panel', rsModal);
        var mrpLast = mrpPanels[mrpPanels.length - 1];
        if (mrpLast && mrpLast.parentElement) mrpLast.parentElement.appendChild(mailPanel);
      }
    }

    $$('.rs-tab', rsModal).forEach(function (tab) {
      tab.addEventListener('click', function () {
        $$('.rs-tab', rsModal).forEach(function (x) { x.classList.remove('active'); });
        $$('.rs-panel', rsModal).forEach(function (x) { x.classList.remove('active'); });
        tab.classList.add('active');
        var p = rsModal.querySelector('.rs-panel[data-panel="' + tab.getAttribute('data-tab') + '"]');
        if (p) p.classList.add('active');
      });
    });

    if (rsCal) rsCal.addEventListener('input', rsUpdate);
    if (rsSize) rsSize.addEventListener('input', rsUpdate);

    var rsBody = $('#rsChartBody');
    if (rsBody && !rsBody.children.length) {
      RS_SIZES.forEach(function (s) {
        var tr = document.createElement('tr');
        tr.innerHTML = '<td>' + s.us + '</td><td>' + s.dia + ' mm</td><td>' + s.circ + ' mm</td><td>' + s.uk + '</td><td>' + s.eu + '</td>';
        rsBody.appendChild(tr);
      });
    }
  }
})();
